<template>
  <div class="section" style="flex-direction: row;padding: 20px 20px 10px 20px">
    <el-form :disabled="readonly" :inline="true" label-width="90px" label-position="left">
      <el-form-item>
        <span class="title">{{ $t('Message.TcDeliveryAddress') }}</span>
        <cargo-rich-textarea
          v-model="form.deliveryAddress"
          :disabled="readonly"
          style="height: 270px;width:500px"
          @dblclick.native="showAdvanceTextDialog($t('Message.TcDeliveryAddress'),form.deliveryAddress,val=>{form.deliveryAddress=val})"
        />
      </el-form-item>
    </el-form>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    ><cargo-rich-textarea
       v-model="advanceTextDialog.value"
       :disabled="readonly"
       style="height: 198px;"
     />
      <span slot="footer">
        <el-button v-show="!readonly" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'

export default {
  name: 'TerminalCompany',
  components: { cargoRichTextarea },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {
        deliveryAddress: ''
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false
      }
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    }
  },
  created() {
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row
      }
    },
    getSubmitData() {
      const form = this.form
      return { company: form }
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    }
  }
}
</script>
